import React, { useContext } from 'react';
import cn from 'classnames';
import {
  BiData,
  BiContextProvidedValue,
  EditorButtonClickBiEvent,
} from '@wix/da-bi/pkg/events';
import IconButton, {
  Props as IconButtonProps,
} from '@wix/da-ds/pkg/Buttons/IconButton';
import type { RequiresAccessibleLabel } from '@wix/da-a11y/pkg/typeHelpers';
import { EditorContext } from '../../../Editor/Context';
import { TOOLTIP_HOVER_DELAY } from '../../../../constants';

import s from './EditorIconButton.scss';

interface BaseProps extends Omit<IconButtonProps, 'size'> {
  featureId: string;
  isActive?: boolean;
}

type Props = RequiresAccessibleLabel<BaseProps>;

const EditorIconButton: React.FC<Props> = ({
  featureId,
  isActive,
  ...props
}) => {
  const { ref: editor } = useContext(EditorContext);
  return (
    <IconButton
      className={cn(s['root'], isActive && s['is-active'])}
      biData={BiData<EditorButtonClickBiEvent>({
        evid: 193,
        view: BiContextProvidedValue,
        component: BiContextProvidedValue,
        itemid: BiContextProvidedValue,
        typeid: BiContextProvidedValue,
        preset: editor?.storage['da-presetId'] || 'unknown',
        feature: featureId,
      })}
      size="large"
      tooltipHoverDelay={TOOLTIP_HOVER_DELAY}
      {...props}
    />
  );
};
EditorIconButton.displayName = 'EditorIconButton';

export default EditorIconButton;
